import $ from "jquery";
import { RSNA_VALIDATION_MSG } from "../../../constants/Constants";

var rsnaTemplateId;
let normal_statements = [];
let impression_statement = [];
let order = new Array();
let normal_statements_map = new Map();


export const sanitizeInputValues = (str) => {
      // Step 1: Remove script and style tags
      str = str.replace(/<\s*\/?(script|style)[^>]*>/gi, "");

      // Step 2: Remove potentially harmful attributes
      str = str.replace(/<[^>]*(on\w+\s*=\s*["'][^"']*["']|style\s*=\s*["'][^"']*["'])[^>]*>/gi, "");

      // Step 3: Escape remaining angle brackets to prevent any other tag injections
      str = str.replace(/</g, "&lt;").replace(/>/g, "&gt;");

      return str;
}

export const generateRSNAReport = () => {
	console.log("generateRSNAReport");

  var procedure = document.getElementsByClassName("procedure");
  for (let i = 0; i < procedure.length; ) {
    if (!procedure[i].children[0]?.checked) {
      procedure[i].remove();
      continue;
    }
    i++;
  }

  var procedureChecked = document.getElementsByClassName("procedure");
  for (let i = 0; i < procedureChecked.length; i++) {
    if (procedureChecked[i].children[0].checked) {
      procedureChecked[i].children[0].remove();
    }
  }

  var studyReason = document.getElementsByClassName("reasonforStudy");
  if (studyReason[1].children[0]?.checked) {
    var studyReasonVar = $("#CHECKBOX_1542229828893_1_FreeText").val();
    studyReasonVar = replaceTags(studyReasonVar);
    document.getElementById("reasonforStudyId").innerHTML = studyReasonVar;
    $("#CHECKBOX_1542229828893_1_FreeText").remove();
  }
  for (let i = 0; i < studyReason.length; ) {
    if (!studyReason[i].children[0]?.checked) {
      studyReason[i].remove();
      continue;
    }
    i++;
  }

  var studyReasonChecked = document.getElementsByClassName("reasonforStudy");
  for (let i = 0; i < studyReasonChecked.length; i++) {
    if (studyReasonChecked[i].children[0]?.checked) {
      studyReasonChecked[i].children[0].remove();
    }
  }

  if (!document.getElementById("clinicalInformationText").value == "") {
    var commentVar = $("#clinicalInformationText").val();
    commentVar = sanitizeInputValues(commentVar);

    commentVar = replaceTags(commentVar);
    document.getElementById("clinicalInfoId").innerHTML = commentVar;
    $("#clinicalInformationText").remove();
  } else {
    $("#commentTitle").remove();
    $("#commentSubDiv").remove();
    $("#commentEmptyDiv").remove();
  }

  var valueDate = document.getElementById("DATE_1542586542564").value;
  if (valueDate == null || valueDate == "") {
    $("#dateTitle").remove();
    $("#dateSubDiv").remove();
    $("#dateEmptyDiv").remove();
    $("#comparisonDateId").remove();
  } else {
    var currentLocale = $("#currentLocale").val();

    if (currentLocale == "ja_JP") {
      var dateVar = $("#DATE_1542586542564").val();

      var day = dateVar.substring(0, 2);
      var month = dateVar.substring(3, 6);
      var year = dateVar.substring(7, 11);

      var monthNumber = new Date(Date.parse(month + "1")).getMonth() + 1;

      var JPdate = year + "/" + monthNumber + "/" + day;

      document.getElementById("comparisonDateId").innerHTML = JPdate;
      $("#dateSubDiv").remove();
    } else {
      var dateVar = $("#DATE_1542586542564").val();
      document.getElementById("comparisonDateId").innerHTML = dateVar;
      $("#dateSubDiv").remove();
    }
  }

  var TBfindings = document.getElementsByClassName("TBfindings");
  for (let i = 0; i < TBfindings.length; ) {
    if (!TBfindings[i].children[0]?.checked) {
      TBfindings[i].remove();
      continue;
    }
    i++;
  }

  var TBfindingsChecked = document.getElementsByClassName("TBfindings");
  if (TBfindingsChecked.length == 0) {
    $("#TBfindingsTitle").remove();
    $("#TBfindingsEmptyDiv").remove();
  }
  for (let i = 0; i < TBfindingsChecked.length; i++) {
    if (TBfindingsChecked[i].children[0]?.checked) {
      TBfindingsChecked[i].children[0].remove();
    }
  }

  var oldTBfindings = document.getElementsByClassName("oldTBfindings");
  for (let i = 0; i < oldTBfindings.length; ) {
    if (!oldTBfindings[i].children[0]?.checked) {
      oldTBfindings[i].remove();
      continue;
    }
    i++;
  }

  var oldTBfindingsChecked = document.getElementsByClassName("oldTBfindings");
  if (oldTBfindingsChecked.length == 0) {
    $("#oldTBfindingsTitle").remove();
    $("#oldTBfindingsEmptyDiv").remove();
  }
  for (let i = 0; i < oldTBfindingsChecked.length; i++) {
    if (oldTBfindingsChecked[i].children[0]?.checked) {
      oldTBfindingsChecked[i].children[0].remove();
    }
  }

  if (!document.getElementById("findingsText").value == "") {
    var otherFindingsVar = $("#findingsText").val();
    otherFindingsVar = sanitizeInputValues(otherFindingsVar);
    otherFindingsVar = replaceTags(otherFindingsVar);
    document.getElementById("otherFindingsId").innerHTML = otherFindingsVar;
    $("#findingsText").remove();
  } else {
    $("#otherFindingsTitle").remove();
    $("#otherFindingsSubDiv").remove();
    $("#otherFindingsEmptyDiv").remove();
  }

  var impression = document.getElementsByClassName("impression");
  for (let i = 0; i < impression.length; ) {
    if (!impression[i].children[0]?.checked) {
      impression[i].remove();
      continue;
    }
    i++;
  }

  var impressionChecked = document.getElementsByClassName("impression");
  for (let i = 0; i < impressionChecked.length; i++) {
    if (impressionChecked[i].children[0]?.checked) {
      impressionChecked[i].children[0].remove();
    }
  }

  if (!document.getElementById("impressionText").value == "") {
    var otherImpressionVar = $("#impressionText").val();
    otherImpressionVar = sanitizeInputValues(otherImpressionVar);
    otherImpressionVar = replaceTags(otherImpressionVar);
    document.getElementById("otherImpressionsId").innerHTML =
      otherImpressionVar;
    $("#impressionText").remove();
  } else {
    $("#otherImpressionTitle").remove();
    $("#otherImpressionSubDiv").remove();
    $("#otherImpressionEmptyDiv").remove();
  }

  let rsnaTb = $("#rsnaPopupContext").html();
  return $("#rsnaPopupContext").html();
//   popupCloseAction();
// console.log("Final values");
//   console.log(rsnaReportState.selectedVal);
//   console.log(rsnaReportState.selectedText);
//   console.log(rsnaTb);
//   var isExternal = $("#isExternal").val() == "true" ? true : false;
//   addReportTab(
//     rsnaReportState.selectedVal,
//     rsnaReportState.selectedText,
//     rsnaTb,
//     "",
//     isExternal
//   );
}

function replaceTags(element) {
    if(element == undefined)return;
    return element.replace(
      /(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/gi,
      ""
    );
  }

export const updateRSNAReport = () => {

    //  $('div').draggable();
//     $('.input-group.date').datepicker({
//                     format: 'dd-MM-yyyy',
//              		clearBtn: true,
//              		todayBtn: "linked",
//                     todayHighlight: true,
//              		autoclose: true
//             });

//     $(function () {
// 	 $(".accordion").sortable();
// 	 $("#findings_div").sortable();
//   /*  $("#findings_div").sortable();
//         $("#sectionList").sortable();*/

//     });
//	$(".accordion").accordion({ collapsible: true, active: false });
    $("input[type=checkbox]").prop('checked', true);
	$(".rsna-card").each(function () {
       // let array = [];
        let card_heading;
        $(this).children().each(function () {
            if ($(this).attr('class') == 'card-header rsna-card-header') {
                card_heading = $(this)[0].outerText || $(this)[0].innerText;
                //console.log(card_heading);
            } else {
               if(card_heading == 'FINDINGS') {
                    let arr = [];
                    $("input[type=checkbox]:checked").each(function () {
                        //console.log("findings : " + $(this).attr('name'));
                        let name = $(this).attr('name');
                        let element = '#' + name;
                        let element_text = '#' + name + '-text';
                        if (!element.includes("#includeImage")) {
                    $(element).each(function () {
                        // console.log($(element).val());
                        if ($(element).val() !== null && $(element).val() !== undefined && $(element).val() !== " " && $(element).val() !== ""){
                          let element_str = sanitizeInputValues($(element).val());  
                          arr.push(element_str);
                        }
                          
                          normal_statements_map[element.toString()] = $(element).val();
                    });
                    if ($(element_text).length) {
                        // console.log($(element_text).val());
                        if ($(element_text).val() !== null && $(element_text).val() !== undefined && $(element_text).val() !== " " && $(element_text).val() !== ""){
                          let element_str = sanitizeInputValues($(element_text).val()); 
                          arr.push(element_str);
                        }
                        normal_statements_map[element_text.toString()] = $(element_text).val();
                    }
                }

                    });
                    normal_statements = arr;
            		//console.log(normal_statements);
					//console.log(normal_statements_map);
                }

            }

        });
       // console.log(array)
    })

    let impression_statement_text = $('textarea[name="Impression"]').val();
    impression_statement_text = sanitizeInputValues(impression_statement_text);
    impression_statement.push(impression_statement_text);

};

export function getSelectionsForRSNAFunc(){
  let content = new Map();
  order = [];
  console.log("--- RSNA CARD ----");
  console.log($(".rsna-card"));
      $(".rsna-card").each(function () {
          let array = [];
          let card_heading;
          $(this).children().each(function () {
              if ($(this).attr('class') == 'card-header rsna-card-header') {
                  card_heading = $(this)[0].outerText || $(this)[0].innerText;
                  // console.log(card_heading);
                  order.push(card_heading);
              } else {
                  if (card_heading !== 'FINDINGS') {
                      $(this).find('input,select,textarea,label').each(function () {
                          if (this.tagName != 'LABEL') {
                              // console.log($(this).val())
                              if (card_heading !== 'COMPARISON') {
                                  if ($(this).val() !== null && $(this).val() !== undefined && $(this).val() !== " " && $(this).val() !== "" && $(this).val() !== "Other."){
                                    let sanitizeStr = sanitizeInputValues($(this).val());
                                    array.push(sanitizeStr);
                                  }
                              } else {
                                  if ($(this).val() == null || $(this).val() == undefined || $(this).val() == ""){
                                    array.push('None')
                                  } else{
                                    let sanitizeStr = sanitizeInputValues($(this).val());
                                    array.push(sanitizeStr);
                                  }
                              }
  
                          } else {
                            let sanitizeStr = sanitizeInputValues(this.innerText);
                            array.push(sanitizeStr);
                          }
  
                      });
                      if (card_heading == "TECHNIQUE") {
                          let s = array.toString();
                          let s1 = s.replaceAll(',',', ');
                          let s2 = replaceChar(s,' ',s.lastIndexOf(","));
                          let s3 = s2.replace(/\s+/g, ' ').trim();
                          let array1 = []
                          array1.push(s3);
                          content[card_heading] = array1;
                      } else {
                          content[card_heading] = array;
                      }
                  } else {
                      let arr = [];
                      $("input[type=checkbox]:checked").each(function () {
                          //console.log("findings : " + $(this).attr('name'));
                          let name = $(this).attr('name');
                          let element = '#' + name;
                          let element_text = '#' + name + '-text';
                       if (!element.includes("#includeImage")) {
                      $(element).each(function () {
                          // console.log($(element).val());
                          if ($(element).val() !== null && $(element).val() !== undefined && $(element).val() !== " " && $(element).val() !== ""){
                            let sanitizedStr = sanitizeInputValues($(element).val());
                            arr.push(sanitizedStr);
                          }
                              
                      });
                      if ($(element_text).length) {
                          // console.log($(element_text).val());
                          if ($(element_text).val() !== null && $(element_text).val() !== undefined && $(element_text).val() !== " " && $(element_text).val() !== ""){
                            let sanitizedStr = sanitizeInputValues($(element_text).val());
                            arr.push(sanitizedStr);
                          }
                              
                      }
                  }
  
                      });
                      content[card_heading] = arr;
                  }
  
              }
  
          });
          //console.log(array)
      });
      let arr1 = [];
      arr1.push($("#span_title")[0].innerText);
      content['report-title'] = arr1;
      content['normal-statements'] = normal_statements;
      content['impressions-normal'] = impression_statement
      console.log(content)
      console.log(order);
      
  
      let submittedValues = JSON.stringify(content);
      let validation_res = validateSelections();
      if (validation_res != null) {
         // popupCloseActionRsna();
        order = [];

        //alert(validation_res.message);
          //showAlert(validation_res.message, function () {});
          return {error:true, message: validation_res.message};
          //return null;
  
      }
    
    console.log(order);
      const rsnaForm = $("form[name='form_rsna_new']");
      let rsnaData = rsnaForm.serializeArray();
      rsnaData.push({
          name: 'values',
          value: submittedValues
      })
  
      rsnaData.push({
          name: 'templateName',
          value: 'rsna_template'
      })
  
      rsnaData.push({
          name: 'reportOrder',
          value: order
      })
      return rsnaData;
}

export const handleChangeValues = (e,props) => {
  
  if(props.content.text == "TUBERCULOSIS" && e != null){

    console.log("Running handleChangeValues");
    if (
      e.target.id != "impressionText" ||
      $(e.target).parents("#impressionText").length
    ) {
      $("#impressionText").blur();
    }
    if (
      e.target.id != "DATE_1542586542564" ||
      $(e.target).parents("#DATE_1542586542564").length
    ) {
      $("#DATE_1542586542564").blur();
    }
    if (
      e.target.id != "findingsText" ||
      $(e.target).parents("#findingsText").length
    ) {
      $("#findingsText").blur();
    }
    if (
      e.target.id != "clinicalInformationText" ||
      $(e.target).parents("#clinicalInformationText").length
    ) {
      $("#clinicalInformationText").blur();
    }
    if (
      e.target.id != "CHECKBOX_1542229828893_1_FreeText" ||
      $(e.target).parents("#CHECKBOX_1542229828893_1_FreeText").length
    ) {
      $("#CHECKBOX_1542229828893_1_FreeText").blur();
    }

  document.getElementById("DATE_1542586542564").type = 'date';
  document.getElementById("procedureTitle").style.height = '2em';
  document.getElementById("reasonforStudyTitle").style.height = '2em';
  document.getElementById("commentTitle").style.height = '2em';
  document.getElementById("TBfindingsTitle").style.height = '2em';
  document.getElementById("oldTBfindingsTitle").style.height = '2em';
  document.getElementById("otherFindingsTitle").style.height = '2em';
  document.getElementById("impressionTitle").style.height = '2em';
  document.getElementById("otherImpressionTitle").style.height = '2em';
  // $("#rsna-title").text(props.content.text.replace("SR", ""));

 }
 $("#DATE_1542586542564").removeClass();
 $(".input-group-addon").css("display", "none");
}


export function validateSelections() {
    let clinical_history_option = $('#clinical-information').val();
    let clinical_history_comment = $('#clinical_info_text').val();
    clinical_history_comment = sanitizeInputValues(clinical_history_comment);
    let limitation_option = $('#limitations').val();
    let limitation_comment = $('#limitations_text').val();
    limitation_comment = sanitizeInputValues(limitation_comment);

    if (clinical_history_option === 'Other.' && (clinical_history_comment == null || clinical_history_comment == undefined || clinical_history_comment == "" || clinical_history_comment == " ")) {
        return {
            error: 1,
            message: RSNA_VALIDATION_MSG._iMessageRsnaClinicalHistoryError
            //message:"Clinial History Error"
        };
    }
    if (limitation_option === 'Other.' && (limitation_comment == null || limitation_comment == undefined || limitation_comment == "" || limitation_comment == " ")) {
        return {
            error: 1,
            message: RSNA_VALIDATION_MSG._iMessageRsnaLimitationError
           //message:"Rsna Limitation Error"
        };
    }
    if(!checkIfFindingAreSelected()){
        return {
                    error: 1,
                    message: RSNA_VALIDATION_MSG._iMessageRsnaFindingSelectionError
                   // message:"Finding selection error"
                };
    }
    else {
        return null;
    }

}

export function checkIfFindingAreSelected(){
    let c =0;
        $("input[type=checkbox]:checked").each(function () {
                                //console.log("findings : " + $(this).attr('name'));
                                let name = $(this).attr('name');
                                let element = '#' + name;
                             if (!element.includes("#includeImage")) {
                                    c = c + 1;
                        }
    
                            });
    
        if ( c == 0){
            return false;
        }
        else
            return true;
    }

export function replaceChar(origString, replaceChar, index) {
        let firstPart = origString.substr(0, index);
        let lastPart = origString.substr(index + 1);
    
        let newString = firstPart + replaceChar + lastPart;
        return newString;
    }
